import React from 'react'
import PortfolioExample from '../Components/PortfolioExample'
import RV from '../Images/RunVeggies.png'
import GV from '../Images/GalacticVeins.png'
import AL from '../Images/Afterlight.png'

const gameProjects = [
  {
    title: "Run, Veggies!",
    image: RV,
    description: "Trapped in a sinister food processing facility, three unlikely heroes must team up to escape their culinary fate. Use each veggie's unique abilities to solve puzzles, dodge deadly machinery, and outwit the kitchen crew in this quirky, fast-paced adventure.",
    services: "Product Management, Community Management, Marketing, Web Development",
    link: "https://www.runveggies.com/",
    type: "Game"
  },
  {
    title: "Galactic Veins",
    image: GV,
    description: "Embark on an epic journey where the cosmos is your battleground, and resources are the key to galactic supremacy. A Scifi survival adventure that mixes exploration, resource management, and strategic combat.",
    services: "Development Support, Marketing Support, Web Design",
    link: "https://www.galacticveins.com/",
    type: "Game"
  },
  {
    title: "Afterlight",
    image: AL,
    description: "A 3D puzzle platformer where players work with friends to find runes and complete an ancient ritual. Winner of 'Best Peaceful Game' at the 2023 Global Game Jam.",
    services: "Project Management, Development Support",
    link: "https://jimdublace.itch.io/afterlight",
    type: "Game"
  }
]

const webProjects = [
  {
    title: "JimDublace Studios",
    description: "A game development studio specializing in creating learning opportunities for aspiring game developers through Learning, Mentoring, and Community. A division of Wallace Software Consulting, LLC.",
    services: "Web Design, Marketing Support",
    link: "https://jimdublace.com",
    type: "Web"
  },
  {
    title: "Dad Bod Run Club",
    description: "A running group promoting men's health and networking in Amesbury and surrounding communities. The website serves as a hub providing information about events and local health resources.",
    services: "Web Design, Marketing Support",
    link: "https://www.dadbodrunclub.com/",
    type: "Web"
  }
]

function Portfolio() {
  return (
    <div className='bg-gradient-to-b from-slate-50 to-white min-h-screen'>
      {/* Hero Section */}
      <div className='py-16 lg:py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900'>
        <div className='max-w-4xl mx-auto px-6 lg:px-8 text-center'>
          <h1 className='hero-title mb-6'>Project Portfolio</h1>
          <p className='text-lg md:text-xl text-slate-300 leading-relaxed max-w-3xl mx-auto'>
            Explore our diverse range of projects, showcasing our expertise and creativity across 
            game development, web applications, and digital solutions.
          </p>
        </div>
      </div>

      <div className='max-w-7xl mx-auto px-6 lg:px-8 py-16'>
        {/* Game Development Section */}
        <div className='mb-20'>
          <div className='text-center mb-12'>
            <div className='flex items-center justify-center gap-3 mb-4'>
              <div className='w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center'>
                <svg className='w-6 h-6 text-white' fill='currentColor' viewBox='0 0 24 24'>
                  <path d='M21.58 16.09l-1.09-7.66C20.21 6.46 18.52 5 16.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66C2.2 17.63 3.39 19 4.94 19h0c.68 0 1.32-.27 1.8-.75L9 16h6l2.25 2.25c.48.48 1.12.75 1.8.75h0c1.56 0 2.75-1.37 2.53-2.91zM11 11H9v2H7v-2H5V9h2V7h2v2h2v2zm6.5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2-3c-.83 0-1.5-.67-1.5-1.5S18.67 5 19.5 5 21 5.67 21 6.5 20.33 8 19.5 8z'/>
                </svg>
              </div>
              <h2 className='text-3xl md:text-4xl font-semibold text-slate-800'>Game Development Projects</h2>
            </div>
            <p className='text-slate-600 max-w-2xl mx-auto'>
              From puzzle platformers to survival adventures, our games showcase creativity and technical excellence.
            </p>
          </div>
          
          <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-8'>
            {gameProjects.map((project, index) => (
              <PortfolioExample
                key={index}
                title={project.title}
                description={project.description}
                services={project.services}
                image={project.image}
                link={project.link}
                type={project.type}
              />
            ))}
          </div>
        </div>

        {/* Web Development Section */}
        <div className='mb-16'>
          <div className='text-center mb-12'>
            <div className='flex items-center justify-center gap-3 mb-4'>
              <div className='w-12 h-12 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center'>
                <svg className='w-6 h-6 text-white' fill='currentColor' viewBox='0 0 24 24'>
                  <path d='M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z'/>
                </svg>
              </div>
              <h2 className='text-3xl md:text-4xl font-semibold text-slate-800'>Web Development Projects</h2>
            </div>
            <p className='text-slate-600 max-w-2xl mx-auto'>
              Professional websites and digital solutions that help businesses connect with their communities.
            </p>
          </div>
          
          <div className='grid md:grid-cols-2 gap-8 max-w-4xl mx-auto'>
            {webProjects.map((project, index) => (
              <PortfolioExample
                key={index}
                title={project.title}
                description={project.description}
                services={project.services}
                link={project.link}
                type={project.type}
              />
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className='text-center'>
          <div className='card p-8 max-w-2xl mx-auto'>
            <h3 className='text-2xl font-semibold text-slate-800 mb-4'>Ready to Start Your Project?</h3>
            <p className='text-slate-600 mb-6 leading-relaxed'>
              Whether you need a mobile game, web application, or custom software solution, 
              we're here to help bring your vision to life.
            </p>
            <a href='/contact' className='btn-primary inline-flex items-center gap-2'>
              Start Your Project
              <svg className='w-4 h-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M17 8l4 4m0 0l-4 4m4-4H3' />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Portfolio